import React, { createContext } from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import ReactQueryDevTools from './ReactQueryDevTools';

export const ReactQueryContext = createContext({});
ReactQueryContext.displayName = 'ReactQueryContext';

export const queryClient = new QueryClient();

export default function ReactQueryProvider({ client = queryClient, children }) {
  return (
    <QueryClientProvider client={client} contextSharing>
      {children}
    </QueryClientProvider>
  );
}

export function withReactQueryWrapper(Component) {
  const ReactQueryWrapper = props => (
    <ReactQueryProvider>
      <Component {...props} />
      <ReactQueryDevTools />
    </ReactQueryProvider>
  );

  return props => <ReactQueryWrapper {...props} />;
}
